/**
 * File: stockDetails.js
 * Project: educore
 * Created Date: 2019-03-15
 * Author: Raziya S
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
class StockDetailsController {
    // @ngInject
    constructor($scope, $rootScope, localStorageService, $state, MEDICALCONSTANT, authService, CONSTANTS, SchoolLogo) {

        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
        }
        let schoolId = localStorageService.get('school_id')
        $scope.pageSize = 50;
        $scope.totalCount = 0;
        $scope.errors = {}
        $scope.addInventoryRedirect = () => {
            $state.go('addInventory')
        }
        authService.callAPI(MEDICALCONSTANT.API_GET_SCHOOL_DETAILS + schoolId, "POST", {}, (response) => {
            if (response.result && response.result.status && response.result.data.details) {
                let result = response.result.data.details
                $scope.schoolHeader = {
                    'schoolName': result.school_name,
                    'schoolLogo': SchoolLogo.checkLogo(CONSTANTS.FILE_UPLOAD_URL + result.logo),
                }
                convertFileToDataURLviaFileReader($scope.schoolHeader.schoolLogo, function(base64Image) {
                    $scope.imgurl1 = base64Image;
                })
            }
        })

        function convertFileToDataURLviaFileReader(url, callback) {
            console.log(url)
            var xhr = new XMLHttpRequest();
            xhr.onload = function() {
                var reader = new FileReader();
                reader.onloadend = function() {
                    callback(reader.result);
                }
                reader.readAsDataURL(xhr.response);
            };
            xhr.open('GET', url);
            xhr.responseType = 'blob';
            xhr.send();
        };

        function getDataUri(url, callback) {
            var xhr = new XMLHttpRequest();
            xhr.onload = function() {
                var reader = new FileReader();
                reader.onloadend = function() {
                    callback(reader.result);
                }
                reader.readAsDataURL(xhr.response);
            };
            xhr.open('GET', url);
            xhr.responseType = 'blob';
            xhr.send();
        }

        $scope.generatePdf = (pdfDetails) => {
            let obj = {
                school_id: schoolId
            }
            authService.callAPI(MEDICALCONSTANT.API_GET_INVENTORY_PDF, "POST", obj, (response) => {
                if (response.result && response.result.data && response.result.data.data) {
                    let productDetails = response.result.data.data
                    let content = [];
                    content.push({
                        columns: [{
                                width: 70,
                                height: 70,
                                image: $scope.imgurl1
                            },
                            [{}, {
                                alignment: 'center',
                                columns: [{
                                    text: $scope.schoolName,
                                    style: 'title'
                                }]
                            }, {
                                alignment: 'center',
                                columns: [{
                                    text: "Inventory of Medicine"
                                }]
                            }]
                        ]
                    })
                    content.push({
                        canvas: [{
                            type: 'line',
                            x1: 0,
                            y1: 10,
                            x2: 760,
                            y2: 10,
                            lineWidth: 0.5
                        }]
                    })
                    content.push("\n")
                    let body = [];
                    let header = [{
                        text: "Sr No.",
                        style: 'tableHeader',
                        alignment: 'center'
                    }, {
                        text: "Product Name",
                        style: 'tableHeader',
                        alignment: 'center'
                    }, {
                        text: "Batch Id",
                        style: 'tableHeader',
                        alignment: 'center'
                    }, {
                        text: "Opening Stock",
                        style: 'tableHeader',
                        alignment: 'center'
                    }, {
                        text: "Stock In (Purchased) Units",
                        style: 'tableHeader',
                        alignment: 'center'
                    }, {
                        text: "Stock Out (Consumed) Units",
                        style: 'tableHeader',
                        alignment: 'center'
                    }, {
                        text: "Closing Stock Units",
                        style: 'tableHeader',
                        alignment: 'center'
                    }]
                    body.push(header)
                    let sortedList = _.sortBy(productDetails, 'medicine_name');
                    _.each(sortedList, function(product, index) {
                        let detail = [index + 1, product.medicine_name, product.batch_no, 0, product.vials_count * product.quantity, (product.vials_count * product.quantity) - product.remaining_count, product.remaining_count]
                        body.push(detail)
                    })
                    console.log(body)
                    let table = {
                        style: 'tableExample',
                        table: {
                            widths: [25, 300, 'auto', 'auto', 'auto', 'auto', 'auto'],
                            body: body
                        }
                    }
                    content.push(table)

                    var docDefinition = {
                        pageOrientation: 'landscape',
                        content: content,
                        styles: {
                            title: {
                                fontSize: 18,
                                bold: true,
                                alignment: 'center'
                            },
                            sectionTitle: {
                                bold: true,
                                italics: true
                            },
                            boldStyle: {
                                bold: true
                            },
                            tableExample: {
                                margin: [0, 5, 0, 15]
                            },
                            tableHeader: {
                                bold: true,
                                fontSize: 13,
                                color: 'black'
                            }
                        }
                    }
                    pdfMake.createPdf(docDefinition).open();
                }
            })
        }

        /*********** Prototype for pagination: START ******************/
        function stockItems() {
            this.loadedPages = {}; //details of loaded pages on scroll
            this.numItems = 0; //total number of items
            this.PAGE_SIZE = $scope.pageSize; //number of items per page
            this.fetchPage_(0);
        };

        //To get the item at the index
        //index -> current index
        stockItems.prototype.getItemAtIndex = function(index) {
            //calculate the page number of the given index
            let pageNumber = Math.floor(index / this.PAGE_SIZE);
            let page = this.loadedPages[pageNumber];
            //if page items are loaded
            if (page) {
                return page[index % this.PAGE_SIZE];
            } else if (page !== null) {
                //else fetch the page content. calling method to fetch item from db
                this.fetchPage_(pageNumber);
            }
        };

        //To get the total number of items
        stockItems.prototype.getLength = function() {
            return this.numItems;
        };

        //To fetch the items from db
        //pageNumber -> number for which page the items to be fetched
        stockItems.prototype.fetchPage_ = function(pageNumber) {
            this.loadedPages[pageNumber] = null;
            //To calculate the page offset(number of items to be skiped)
            let pageOffset = pageNumber * this.PAGE_SIZE;
            let paginationOpts = {
                limit: parseInt(this.PAGE_SIZE),
                skip: parseInt(pageOffset),
            };
            let obj = {
                pagination_options: paginationOpts,
                school_id: schoolId
            }
            authService.callAPI(MEDICALCONSTANT.API_GET_INVENTORY_LIST, "POST", obj, (response) => {
                if (response.result && response.result.data && response.result.data.data) {
                    this.numItems = response.result.data.data.count
                    this.totalCount = response.result.data.data.count
                    $scope.medicineCount = response.result.data.data.count
                    this.loadedPages[pageNumber] = response.result.data.data.list
                    $scope.productDetails = response.result.data.data.list
                    _.defer(function() {
                        $scope.$apply();
                    });
                }
            })
        };

        $scope.productList = new stockItems();
    }
}
export default StockDetailsController



// WEBPACK FOOTER //
// ./src/app/medical/controllers/inventory/stockDetails.js